/* eslint-disable */
export default {
  dialPlaceholder: 'Inserisci nome o numero',
} as const;

// @key: @#@"dialPlaceholder"@#@ @source: @#@"Enter name or number"@#@
